module.exports = __webpack_public_path__ + "img/Number=42.2e4c70a8.png";